export const SKILL_GROUPS_SHOWN_BY_DEFAULT_COUNT = 3;
